import actionCreatorFactory from "typescript-fsa";
import { MenuDetailPopupProps, ModalDataItem, StoreDetailPopupProps } from "./types";

const actionCreator = actionCreatorFactory("@@App");

export const appActions = {
  showLoading: actionCreator("SHOW_LOADING"),
  hideLoading: actionCreator("HIDE_LOADING"),
  showModal: actionCreator.async<ModalDataItem, {}>("SHOW_MODAL"),
  closeModal: actionCreator("CLOSE_MODAL"),
  showContactUsModal: actionCreator("SHOW_CONTACT_US_MODAL"),
  closeContactUsModal: actionCreator("CLOSE_CONTACT_US_MODAL"),
  showLanguageMessageModal: actionCreator("SHOW_LANGUAGE_MESSAGE_MODAL"),
  closeLanguageMessageModal: actionCreator("CLOSE_LANGUAGE_MESSAGE_MODAL"),
  showLanguageSelectModal: actionCreator("SHOW_LANGUAGE_SELECT_MODAL"),
  closeLanguageSelectModal: actionCreator("CLOSE_LANGUAGE_SELECT_MODAL"),
  showMenuDetailPopup: actionCreator.async<MenuDetailPopupProps, {}>("SHOW_MENU_DETAIL_POPUP"),
  closeMenuDetailPopup: actionCreator("CLOSE_MENU_DETAIL_POPUP"),
  showStoreDetailPopup: actionCreator.async<StoreDetailPopupProps, {}>("SHOW_STORE_DETAIL_POPUP"),
  closeStoreDetailPopup: actionCreator("CLOSE_STORE_DETAIL_POPUP"),
  setMenuDetailPopupFavorite: actionCreator<boolean>("SET_MENU_DETAIL_POPUP_FAVORITE"),
  setStoreDetailPopupFavorite: actionCreator<boolean>("SET_STORE_DETAIL_POPUP_FAVORITE"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
